/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityRelationStatsCriticalityCount
 */
export interface ControlEntityRelationStatsCriticalityCount {
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationStatsCriticalityCount
     */
    critical?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationStatsCriticalityCount
     */
    high?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationStatsCriticalityCount
     */
    medium?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlEntityRelationStatsCriticalityCount
     */
    low?: number;
}

/**
 * Check if a given object implements the ControlEntityRelationStatsCriticalityCount interface.
 */
export function instanceOfControlEntityRelationStatsCriticalityCount(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityRelationStatsCriticalityCountFromJSON(json: any): ControlEntityRelationStatsCriticalityCount {
    return ControlEntityRelationStatsCriticalityCountFromJSONTyped(json, false);
}

export function ControlEntityRelationStatsCriticalityCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityRelationStatsCriticalityCount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'critical': !exists(json, 'critical') ? undefined : json['critical'],
        'high': !exists(json, 'high') ? undefined : json['high'],
        'medium': !exists(json, 'medium') ? undefined : json['medium'],
        'low': !exists(json, 'low') ? undefined : json['low'],
    };
}

export function ControlEntityRelationStatsCriticalityCountToJSON(value?: ControlEntityRelationStatsCriticalityCount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'critical': value.critical,
        'high': value.high,
        'medium': value.medium,
        'low': value.low,
    };
}

